// extracted by mini-css-extract-plugin
export default {"skelet":"SubMenuListSkelet_skelet--V7R","skeletShimmer":"SubMenuListSkelet_skeletShimmer--ZYW","skeletBlock":"SubMenuListSkelet_skeletBlock--MfY"};